
import { create } from "zustand";
import { devtools } from "zustand/middleware";





const storeApi = (set) => ({

    modalForm: false,
    modalImagen: false,
    modalLateral: false,
    tipo: undefined,


    modalFormToggle: (valor, tipo) => {
        set({ modalForm: valor, tipo })
    },


    toggleModalImg: (valor) => {
        set({ modalImagen: valor })
    },


    modalToggleLateral: (valor) => {
        set({ modalLateral: valor })
    },
    

});





export const useModalStore = create(
    devtools(
        storeApi
    )
)
